module.exports = __webpack_public_path__ + "img/suika ibuki_lw.7aee0239.png";